"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var Field_1 = require("../../../constants/Field");
var DataType_1 = require("./DataType");
var DeepCopy_1 = require("../lib/DeepCopy");
var ISOTimeConverter_1 = require("../lib/ISOTimeConverter");
var DataItem = /** @class */ (function () {
    function DataItem(name, dataType) {
        if (lodash_1.isEmpty(name)) {
            throw new Error("name of the property can not be empty.");
        }
        this.name = name;
        this.dataType = dataType;
    }
    DataItem.fromJson = function (name, json) {
        var dataType = json[Field_1.FIELD.DATATYPE];
        if (lodash_1.isEmpty(name)) {
            throw new Error("name of the property can not be empty.");
        }
        if (!json) {
            throw new Error("dataItemJson can not be undefined.");
        }
        var dataItem = new DataItem(name, dataType);
        dataItem.link = json[Field_1.FIELD.LINK];
        dataItem.value = json[Field_1.FIELD.VALUE];
        if (json[Field_1.FIELD.DESCRIPTION]) {
            dataItem.description = json[Field_1.FIELD.DESCRIPTION];
        }
        if (json[Field_1.FIELD.ENUM]) {
            dataItem.enum = json[Field_1.FIELD.DESCRIPTION];
        }
        if (json[Field_1.FIELD.ITEMS]) {
            dataItem.items = json[Field_1.FIELD.ITEMS];
        }
        if (json[Field_1.FIELD.ISMANDATORY]) {
            dataItem.isMandatory = json[Field_1.FIELD.ISMANDATORY];
        }
        if (json[Field_1.FIELD.TIMEWINDOW]) {
            dataItem.timeWindow = ISOTimeConverter_1.ISOTimeConverter.toISO(json[Field_1.FIELD.TIMEWINDOW]);
        }
        if (json[Field_1.FIELD.SAMPLINGWINDOW]) {
            dataItem.samplingWindow = ISOTimeConverter_1.ISOTimeConverter.toISO(json[Field_1.FIELD.SAMPLINGWINDOW]);
        }
        if (json[Field_1.FIELD.SAMPLINGAGGREGATE]) {
            dataItem.samplingAggregate = json[Field_1.FIELD.SAMPLINGAGGREGATE];
        }
        if (json[Field_1.FIELD.LIMIT]) {
            dataItem.limit = json[Field_1.FIELD.LIMIT];
        }
        if (json[Field_1.FIELD.PATH]) {
            dataItem.path = json[Field_1.FIELD.PATH];
        }
        if (json[Field_1.FIELD.ISDIRTY] !== undefined) {
            dataItem.isDirty = json[Field_1.FIELD.ISDIRTY];
        }
        return dataItem;
    };
    /**
     * Creates a new copy dataItem
     */
    DataItem.prototype.clone = function () {
        var dataItem = new DataItem(this.name, DataType_1.DataType.string);
        dataItem.dataType = this.dataType;
        dataItem.value = this.value;
        dataItem.link = this.link;
        dataItem.description = this.description;
        dataItem.isMandatory = this.isMandatory;
        dataItem.enum = this.enum;
        dataItem.items = this.items;
        dataItem.path = this.path;
        dataItem.timeWindow = this.timeWindow;
        dataItem.samplingWindow = this.samplingWindow;
        dataItem.samplingAggregate = this.samplingAggregate;
        dataItem.limit = this.limit;
        return dataItem;
    };
    DataItem.prototype.removeObjectId = function (isInstance, instanceIds, strictCheck) {
        if (strictCheck === void 0) { strictCheck = true; }
        if ((this.link) && (this.dataType === DataType_1.DataType.array) && strictCheck) {
            var parsedLinks = JSON.parse(this.link);
            var clone_1 = DeepCopy_1.deepCopy(parsedLinks);
            lodash_1.map(parsedLinks, function (parsedLink, index) {
                var parsedSplittedLinks = parsedLink.split('#');
                if (!instanceIds.includes(parsedSplittedLinks[0])) {
                    clone_1[index] = '#' + parsedSplittedLinks[1];
                }
            });
            this.link = JSON.stringify(clone_1);
        }
        else if (this.link && this.link !== '') {
            var splittedLinks = this.link.split('#');
            if (!instanceIds.includes(splittedLinks[0])) {
                var link = '#' + this.link.split('#')[1];
                this.link = link;
            }
        }
    };
    /**
     * Replaces the targetLink from DataItem.link, where link is the stringified array of links
     * @param targetLink a single link from stringified array of link
     * @param newLink link to replace the targetLink
     */
    DataItem.prototype.updateLinkFromArrayOfLinks = function (targetLink, newLink) {
        if (this.dataType !== DataType_1.DataType.array) {
            throw new Error('Datatype should be array');
        }
        var links = JSON.parse(this.link);
        var linkathIndex = links.indexOf(targetLink);
        if (linkathIndex !== -1) {
            links[linkathIndex] = newLink;
        }
        this.link = JSON.stringify(links);
    };
    /**
     * Converts DataItem toJson. The 'name' field will not
     * be a part of this json.
     * @param includeOnlyVariableData if true, will include only value/link/enum field
     */
    DataItem.prototype.toJson = function (includeOnlyVariableData) {
        var json = Object.create(null);
        if (includeOnlyVariableData) {
            json = Object.assign(this.getValueOrLinkField(), this.getTimeWindowField(), this.getSamplingWindowField(), this.getSamplingAggregateField(), this.getLimitField());
            return json;
        }
        json = Object.assign(this.getDataTypeField(), this.getItemsField(), this.getEnumField(), this.getDescriptionField(), this.getIsMandatoryField(), this.getValueOrLinkField(), this.getPathField(), this.getTimeWindowField(), this.getSamplingWindowField(), this.getSamplingAggregateField(), this.getLimitField());
        return json;
    };
    DataItem.prototype.getDefaultItemValue = function (strictCheck) {
        if (strictCheck === void 0) { strictCheck = true; }
        if (!this.dataType) {
            throw new Error("DataType is not defined");
        }
        switch (this.dataType) {
            case DataType_1.DataType.array:
                {
                    var arrayValue = this.items === DataType_1.BasicDataType.integer ? 0 :
                        (this.items === DataType_1.BasicDataType.number ? 0 : (this.items === DataType_1.BasicDataType.boolean ? false : ""));
                    var values = [];
                    var linkValues = undefined;
                    if (strictCheck) {
                        linkValues = this.link ? JSON.parse(this.link) : undefined;
                    }
                    if (linkValues) {
                        for (var i = 0; i < linkValues.length; i++) {
                            values.push(arrayValue);
                        }
                        return values;
                    }
                    return [arrayValue];
                }
                ;
            case DataType_1.DataType.boolean: return false;
            case DataType_1.DataType.integer: return 0;
            case DataType_1.DataType.number: return 0;
            case DataType_1.DataType.string: return "";
            default: return "";
        }
    };
    /**
     * Converts enum field to json.
     * Json will be empty if enum is undefined or empty
     */
    DataItem.prototype.getEnumField = function () {
        var json = Object.create(null);
        if (this.enum && this.enum.length > 0) {
            json[Field_1.FIELD.ENUM] = this.enum;
        }
        return json;
    };
    /**
     * Converts items field to json.
     * Json will be empty if items is undefined
     */
    DataItem.prototype.getItemsField = function () {
        var json = Object.create(null);
        if (this.items) {
            json[Field_1.FIELD.ITEMS] = this.items;
        }
        return json;
    };
    /**
     * Converts dataType field to json.
     */
    DataItem.prototype.getDataTypeField = function () {
        var json = Object.create(null);
        if (this.dataType) {
            json[Field_1.FIELD.DATATYPE] = this.dataType;
        }
        return json;
    };
    /**
     * Converts value/link field to json.
     * Json will be empty if value/link is undefined
     */
    DataItem.prototype.getValueOrLinkField = function () {
        var json = Object.create(null);
        if (this.link !== undefined) {
            json[Field_1.FIELD.LINK] = this.link;
        }
        else if ((this.value === "") || (this.value !== undefined) || (this.value !== null)) {
            json[Field_1.FIELD.VALUE] = this.value;
        }
        if ((this.value === "") || (this.value === undefined)) {
            json[Field_1.FIELD.VALUE] = this.value;
        }
        return json;
    };
    /**
     * Converts description field to json.
     * Json will be empty if description is undefined
     */
    DataItem.prototype.getDescriptionField = function () {
        var json = Object.create(null);
        if (this.description && this.description !== '') {
            json[Field_1.FIELD.DESCRIPTION] = this.description;
        }
        return json;
    };
    /**
     * Converts isMandatory field to json.
     * Json will be empty if isMandatory is undefined
     */
    DataItem.prototype.getIsMandatoryField = function () {
        var json = Object.create(null);
        if (this.isMandatory) {
            json[Field_1.FIELD.ISMANDATORY] = this.isMandatory;
        }
        return json;
    };
    /**
     * Converts path field to json.
     * Json will be empty if path is undefined
     */
    DataItem.prototype.getPathField = function () {
        var json = Object.create(null);
        if (this.path) {
            json[Field_1.FIELD.PATH] = this.path;
        }
        return json;
    };
    /**
     * Converts timeWindow field to json.
     * Json will be empty if timeWindow is undefined
     */
    DataItem.prototype.getTimeWindowField = function () {
        var json = Object.create(null);
        if (this.timeWindow) {
            json[Field_1.FIELD.TIMEWINDOW] = this.timeWindow;
        }
        return json;
    };
    /**
     * Converts samplingWindow field to json.
     * Json will be empty if samplingWindow is undefined
     */
    DataItem.prototype.getSamplingWindowField = function () {
        var json = Object.create(null);
        if (this.samplingWindow) {
            json[Field_1.FIELD.SAMPLINGWINDOW] = this.samplingWindow;
        }
        return json;
    };
    /**
     * Converts samplingAggregate field to json.
     * Json will be empty if samplingAggregate is undefined
     */
    DataItem.prototype.getSamplingAggregateField = function () {
        var json = Object.create(null);
        if (this.samplingAggregate) {
            json[Field_1.FIELD.SAMPLINGAGGREGATE] = this.samplingAggregate;
        }
        return json;
    };
    /**
     * Converts limit field to json.
     * Json will be empty if limit is undefined
     */
    DataItem.prototype.getLimitField = function () {
        var json = Object.create(null);
        if (this.limit) {
            json[Field_1.FIELD.LIMIT] = this.limit;
        }
        return json;
    };
    return DataItem;
}());
exports.DataItem = DataItem;
//# sourceMappingURL=DataItem.js.map